import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { WhatsappShareButton, WhatsappIcon } from 'react-share';
import AddIcon from '@mui/icons-material/Add';
import { blue } from '@mui/material/colors';
import { ANALYTICS_EVENTS } from '../../../constants/MitraContentConstants';
import useMoengage from '../../../hooks/useMoengage';

const SHARE_OPTIONS = {
  WHATSAPP: 'Whatsapp',
};

export default function DialogPopUp(props) {
  const { open, onClose, shareUrl } = props;
  const [, , triggerContentInteractedEvent] = useMoengage();

  const handleClose = () => {
    onClose(shareUrl);
  };

  const handleListItemClick = value => {
    if (value === SHARE_OPTIONS.WHATSAPP) {
      triggerContentInteractedEvent(ANALYTICS_EVENTS.MITRA_BONUS_VIDEO_LINK_SHARED_WHATSAPP, {
        content_url:shareUrl,
      });
    }
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Share</DialogTitle>
      <List sx={{ pt: 0 }}>
        {Object.values(SHARE_OPTIONS).map(platform => (
          <ListItem button onClick={() => handleListItemClick(platform)} key={platform}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                <WhatsappShareButton title="Share on Whatsapp" url={shareUrl}>
                  <WhatsappIcon round />
                </WhatsappShareButton>
              </Avatar>
            </ListItemAvatar>
          </ListItem>
        ))}

        <ListItem autoFocus button onClick={() => handleListItemClick('addAccount')}>
          <ListItemAvatar>
            <Avatar>
              <AddIcon />
            </Avatar>
          </ListItemAvatar>
        </ListItem>
      </List>
    </Dialog>
  );
}

DialogPopUp.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  shareUrl: PropTypes.string.isRequired,
};
